import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PointResponse, EventResponse } from './../../constants/types'

interface PointsState {
  newPointPosition: L.LatLng | null
  editPointPosition: L.LatLng | null
  selectedPoint: PointResponse | null
  selectedPointId: number | null
  currentPoints: PointResponse[] | null
  currentEvents: EventResponse[] | null
}

const initialState: PointsState = {
  newPointPosition: null,
  editPointPosition: null,
  selectedPoint: null,
  selectedPointId: null,
  currentPoints: null,
  currentEvents: null,
}

export const pointsSlice = createSlice({
  name: 'points',
  initialState,
  reducers: {
    setNewPointPosition(state, action: PayloadAction<L.LatLng | null>) {
      state.newPointPosition = action.payload
    },
    setEditPointPosition(state, action: PayloadAction<L.LatLng | null>) {
      state.editPointPosition = action.payload
    },
    setSelectedPoint(state, action: PayloadAction<PointResponse | null>) {
      state.selectedPoint = action.payload
    },
    setSelectedPointId(state, action: PayloadAction<number | null>) {
      state.selectedPointId = action.payload
    },
    setCurrentPoints(state, action: PayloadAction<PointResponse[] | null>) {
      state.currentPoints = action.payload
    },
    setCurrentEvents(state, action: PayloadAction<EventResponse[] | null>) {
      state.currentEvents = action.payload
    },
    addCurrentPoint(state, action: PayloadAction<PointResponse>) {
      state.currentPoints?.push(action.payload)
    },
    removeCurrentPoint(state, action: PayloadAction<number>) {
      state.currentPoints =
        state.currentPoints?.filter((cp) => cp.id !== action.payload) ?? null
    },
    updateCurrentPoint(state, action: PayloadAction<PointResponse>) {
      const target = state.currentPoints?.filter(
        (cp) => cp.id !== action.payload.id
      )
      if (target) {
        state.currentPoints = [...target, action.payload]
      }
    },
  },
})

export const pointsActions = pointsSlice.actions
export const pointsReducer = pointsSlice.reducer
